import { render } from "./ListDataCutiBersama.vue?vue&type=template&id=1616b2bc"
import script from "./ListDataCutiBersama.vue?vue&type=script&lang=js"
export * from "./ListDataCutiBersama.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__